import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-employee-phase-time-compensation-report',
  templateUrl: './employee-phase-time-compensation-report.component.html',
  styleUrls: ['./employee-phase-time-compensation-report.component.css'],
})
export class EmployeePhaseTimeCompensationReportComponent implements OnInit {
  constructor(
    public _apiService: ApiService,
    private notificationService: NzNotificationService,
    private datePipe: DatePipe,
    public cookie: CookieService,

    private modal: NzModalService
  ) {}

  formTitle = 'Employee Wise Project Billing';

  month: any = new Date();

  employeeData: any = [];
  maxColumns: number[] = []; //
  ngOnInit(): void {
    this.onRangeChange(null);
  }

  disabledDate = (current: Date): boolean => {
    const today = new Date();
    // Set the time to 0 to ignore time differences
    today.setHours(0, 0, 0, 0);

    // Disable months after the current month of the current year
    return (
      current &&
      (current.getFullYear() > today.getFullYear() ||
        (current.getFullYear() === today.getFullYear() &&
          current.getMonth() > today.getMonth()))
    );
  };

  startDate: any;
  endDate: any;

  yearChange(data: Date | null) {
    if (data) {
      this.startDate = new Date(data.getFullYear(), data.getMonth(), 1);
      this.endDate = new Date(data.getFullYear(), data.getMonth() + 1, 0);
    } else {
      const currentDate = new Date();
      this.startDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      this.endDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
      );
    }

    const formattedStartDate = this.datePipe.transform(
      this.startDate,
      'yyyy-MM-dd'
    );
    const formattedEndDate = this.datePipe.transform(
      this.endDate,
      'yyyy-MM-dd'
    );

    if (formattedStartDate && formattedEndDate) {
      (this.startDate = formattedStartDate), (this.endDate = formattedEndDate);
    }

    this.getAllEmployeeWiseHoursDetails(true);
  }

  selectedRange: any





  onRangeChange(dates: [Date | null, Date | null]) {
    if (dates && dates[0] && dates[1]) {
      this.startDate = this.datePipe.transform(dates[0], 'yyyy-MM-dd');
      this.endDate = this.datePipe.transform(dates[1], 'yyyy-MM-dd');
    } else {
      this.startDate = null;
      this.endDate = null;
    }
  
    console.log('Start Date:', this.startDate);
    console.log('End Date:', this.endDate);
  
    this.getAllEmployeeWiseHoursDetails(true);
  }

  @ViewChild('table', { static: false }) table: ElementRef;

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = 'desc';
  logtext: string = '';
  searchText: string = '';
  columns: string[][] = [['NAME', 'Name']];
  filterQuery: string = '';
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  projectDataForExcel = [];
  date = new Date();
  scroll = { x: '900px', y: '400px' };
  FinalalizeKey: any;

  getAllEmployeeWiseHoursDetails(reset: boolean = false) {
    var ok = true;

    if (ok) {
      if (reset) {
        this.pageIndex = 1;
      }

      this.loadingRecords = true;

      this.applyFilter();

      this._apiService
        .GETmonthlyBilling(
          this.startDate,
          this.endDate,
          '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94', // projectId
          '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93' // userId
        )
        .subscribe((data) => {
          if (data['code'] == 200) {
            this.FinalalizeKey = data['IS_FINALIZED'];

            console.log(this.FinalalizeKey, 'FinalalizeKey');

            this.loadingRecords = false;
            this.isProjectSpinning = false;
            this.totalRecords = data['count'];
            let demodata = data['results'];

            // Format employee data and calculate totals
            let formatteddata = this.formatEmployeeData(demodata); // Use updated data
            // Add TOTAL_DAYS field to employee data
            this.employeeData = this.calculateTotalDays(formatteddata); // Calculate TOTAL_DAYS

            // Get max columns for dynamic headers
            this.maxColumns = this.getMaxColumns();
            this.initializeMaxColumns();
            const fixedColumnWidth = 260 * 2; // Reduced width for all cases
            const dynamicColumnWidth = this.maxColumns.length * 170; // Adjust multiplier if needed
            // console.log(dynamicColumnWidth , 'dynamic' , fixedColumnWidth , ' fixed ');
            
            const scrollWidth = fixedColumnWidth + dynamicColumnWidth;
            
            this.scroll = { x: scrollWidth + 'px', y: '400px' };

        

            // console.log(this.scroll);

            // Calculate totals for employee data
            this.calculateTotals();

            console.log(this.employeeData);
          } else {
            this.loadingRecords = false;
            this.isProjectSpinning = false;
            this.totalRecords = 0;
            this.employeeData = [];
          }
        });
    }
  }
  calculateTotalDays(employeeData: any[]): any[] {
    return employeeData.map((employee) => {
      if (employee.TOTAL_HOURS) {
        // Split the TOTAL_HOURS into hours, minutes, and seconds
        const timeParts = employee.TOTAL_HOURS.split(':');
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const seconds = parseInt(timeParts[2], 10);

        // Calculate the total hours
        const totalHours = hours + minutes / 60 + seconds / 3600;

        // Calculate the total days by dividing the total hours by 8 (standard workday)
        const totalDays = totalHours / 8;

        // Add the TOTAL_DAYS to the employee record
        return {
          ...employee,
          TOTAL_DAYS: totalDays.toFixed(2), // Rounded to 2 decimal places
        };
      }

      // If there is no TOTAL_HOURS, return the employee data as is
      return employee;
    });
  }

  formatEmployeeData(employeeData: any[]): any[] {
    return employeeData.map((employee) => {
      const formattedEmployee: any = {
        EMP_ID: employee.EMP_ID,
        EMP_NAME: employee.EMP_NAME,
        RATE_PER_HOUR: employee.RATE_PER_HOUR,
        TOTAL_HOURS: employee.TOTAL_HOURS,
        TOTAL_AMOUNT: employee.TOTAL_AMOUNT,
        P: [],
      };

      // Loop through each time/amount field
      Object.keys(employee).forEach((key) => {
        if (key.endsWith('_TIME')) {
          const timeValue = employee[key];
          const amountKey = key.replace('_TIME', '_AMOUNT');
          const amountValue = employee[amountKey];

          //

          // Extract project name from the key (before _TIME/_AMOUNT)
          const projectName = key.replace('_TIME', '');

          // Remove hyphens and underscores from projectName
          const formattedProjectName = projectName.replace(/[-_]/g, ' ');

          // Log the formatted project name for debugging
          //

          // Add project data to P array if time is non-zero and project name is valid
          if (formattedProjectName && formattedProjectName !== 'TOTAL') {
            formattedEmployee.P.push({
              PROJECT_NAME: formattedProjectName, // Project name without hyphens and underscores
              TIME: timeValue, // No conversion for TIME
              AMOUNT: amountValue, // No conversion for AMOUNT
            });
          }
        }
      });

      return formattedEmployee;
    });
  }

  // Function to get the maximum number of columns based on P array length
  initializeMaxColumns(): void {
    //

    const max = Math.max(...this.employeeData.map((e) => e.P.length));
    this.maxColumns = Array.from({ length: max }, (_, i) => i + 1);
    //
  }

  shouldShowTotalDaysColumn(): boolean {
    // Check if any employee has TOTAL_HOURS > 24
    return this.employeeData.some((employee) =>
      this.isMoreThan24Hours(employee.TOTAL_HOURS)
    );
  }

  isMoreThan24Hours(totalHours: string): boolean {
    if (!totalHours) return false;

    const [hours, minutes, seconds] = totalHours.split(':').map(Number);
    const totalInHours = hours + minutes / 60 + seconds / 3600;

    return totalInHours > 24;
  }

  // Function to calculate totals for TIME and AMOUNT for each employee and the P columns
  calculateTotals(): void {
    const totals = {
      EMP_NAME: 'Total',
      DATE: '',
      RATE_PER_HOUR: this.employeeData.reduce(
        (sum, item) => sum + item.RATE_PER_HOUR,
        0
      ),
      TOTAL_AMOUNT: this.employeeData.reduce(
        (sum, item) => sum + item.TOTAL_AMOUNT,
        0
      ),
      TOTAL_HOURS: this.calculateTotalTime(
        this.employeeData.map((item) => item.TOTAL_HOURS)
      ),
      TOTAL_DAYS: this.employeeData
        .reduce((sum, item) => sum + parseFloat(item.TOTAL_DAYS || '0'), 0)
        .toFixed(2), // Sum of TOTAL_DAYS
      P: [],
    };

    // Calculate totals for each P column (TIME and AMOUNT)
    for (let i = 0; i < this.maxColumns.length; i++) {
      const totalTime = this.calculateTotalTime(
        this.employeeData.map((item) => item.P[i]?.TIME || '00:00:00')
      );
      const totalAmount = this.employeeData.reduce(
        (sum, item) => sum + (item.P[i]?.AMOUNT || 0),
        0
      );
      totals.P.push({ TIME: totalTime, AMOUNT: totalAmount.toFixed(2) });
    }

    console.log(totals);
    
    // Append totals row to the data
    this.employeeData.push(totals);
  }

  // Helper method to calculate the total time
  calculateTotalTime(timeStrings: string[]): string {
    let totalSeconds = 0;

    timeStrings.forEach((time) => {
      const [hours, minutes, seconds] = time.split(':').map(Number);
      totalSeconds += hours * 3600 + minutes * 60 + seconds;
    });

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  private getMaxColumns(): number[] {
    // Ensure P array exists for all employees before checking length
    this.employeeData.forEach((employee) => {
      if (!employee.P) {
        employee.P = [];
      }
    });

    // Calculate max length of P arrays
    const maxLength = Math.max(
      ...this.employeeData.map((employee) => employee.P.length)
    );

    return Array.from({ length: maxLength }, (_, i) => i + 1);
  }

  extractProjectNames() {
    // Extract unique project names from employee data
    this.employeeData = [
      ...new Set(
        this.employeeData.flatMap((employee) =>
          employee.PROJECTS.map((project) => project.PROJECT_NAME)
        )
      ),
    ];
  }

  fireEvent() {
    // Check if employeeData is empty
    if (this.employeeData.length <= 1) {
      this.notificationService.info('Data not found', '');
      return; // Exit the function early
    }
    this.loadprojectexcel = true;

    // Collect all unique project names
    const allProjects: any = Array.from(
      new Set(
        this.employeeData.flatMap((employee) =>
          employee.P.map((project) => project.PROJECT_NAME)
        )
      )
    );

    // Prepare header rows
    const headerRow1 = [
      'Employee Name',
      'Rate Per Hour',
      'Total Amount',
      'Total Time',
      'Total Days', // Add Total Days field
      ...allProjects.flatMap((project) => [project, '']), // Project names (we'll merge these cells)
    ];

    const headerRow2 = [
      '',
      '',
      '',
      '',
      '', // Placeholder for TOTAL DAYS subheader
      ...allProjects.flatMap((project, index) => {
        // Only add 'TIME' and 'AMOUNT' for each project, skip for the last project
        if (index === allProjects.length - 1) {
          return []; // No subheader for the last project
        }
        return ['TIME', 'AMOUNT']; // Subheaders for project time and amount
      }),
    ];

    // Prepare data rows and calculate totals
    let totalTime = 0;
    let totalAmount = 0;
    let totalRate = 0;
    let totalDays = 0;
    let projectTimes: any = new Array(allProjects.length).fill(0); // Initialize project time totals
    let projectAmounts = new Array(allProjects.length).fill(0); // Initialize project amount totals

    const employeeRows = this.employeeData.map((employee) => {
      if (employee.EMP_NAME == 'Total') {
        return null; // Return null to skip this row
      }

      const row = [
        employee.EMP_NAME,
        parseFloat(employee.RATE_PER_HOUR).toFixed(2),
        parseFloat(employee.TOTAL_AMOUNT).toFixed(2),
        employee.TOTAL_HOURS,
        employee.TOTAL_DAYS, // Use TOTAL_DAYS key directly
        ...allProjects.flatMap((projectName) => {
          const project = employee.P.find(
            (p) => p.PROJECT_NAME === projectName
          );
          if (project) {
            // Keep the time in hh:mm:ss format without converting to decimal
            const time = project.TIME; // No conversion to decimal
            projectTimes[allProjects.indexOf(projectName)] += this.convertTimeToSeconds(time); // Accumulate project time in seconds
          
            // Accumulate project amount as a number
            const amount = parseFloat(project.AMOUNT) || 0; // Ensure it's treated as a number
            projectAmounts[allProjects.indexOf(projectName)] += amount;
          
            // Return the time and the amount formatted to 2 decimal places for display
            return [time, amount.toFixed(2)];
          }
          
          return ['', '']; // Fill gaps for missing projects
        }),
      ];

      // Calculate totals
      totalTime += this.convertTimeToSeconds(employee.TOTAL_HOURS) || 0; // Accumulate total time in seconds
      totalAmount += employee.TOTAL_AMOUNT || 0; // Accumulate total amount
      totalRate += employee.RATE_PER_HOUR || 0; // Accumulate total rate
      totalDays += parseFloat(employee.TOTAL_DAYS) || 0; // Accumulate total days (ensure numeric)

      return row;
    });

    // Debugging logs for totalDays

    // Add the "Total" row with aggregated data
    const totalRow = [
      'Total', // EMP_NAME for the total row
      totalRate, // Total rate
      totalAmount, // Total amount
      this.convertSecondsToTime(totalTime), // Convert total time from seconds to hh:mm:ss
      totalDays.toFixed(2), // Ensure TOTAL_DAYS for the Total row is formatted correctly
      // ...projectTimes.flatMap((time, index) => {
      //   const amount = projectAmounts[index];
      //   return [this.convertSecondsToTime(time), amount]; // Show total project time and amount in hh:mm:ss format
      // }),
      ...projectTimes.flatMap((time, index) => {
        // Skip the last project
        if (index === projectTimes.length - 1) {
          return []; // Do not include the last project in the total row
        }
        const amount = projectAmounts[index];
        return [this.convertSecondsToTime(time), amount]; // Show total project time and amount in hh:mm:ss format
      }),
    ];

    // Combine headers and data into one array for Excel export
    const worksheetData = [headerRow1, headerRow2, ...employeeRows, totalRow];

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Merge cells for project names (rows 0 to 1)
    const merges = allProjects.map((_, index) => ({
      s: { r: 0, c: 5 + index * 2 }, // Start after the "Total Days" column (index 5)
      e: { r: 0, c: 6 + index * 2 }, // End after the start cell (index + 1)
    }));

    ws['!merges'] = merges;

    // Define column widths
    ws['!cols'] = [
      { wch: 15 }, // DATE
      { wch: 10 }, // RATE
      { wch: 15 }, // TOTAL AMOUNT
      { wch: 15 }, // TOTAL SECONDS
      { wch: 15 }, // TOTAL DAYS
      ...allProjects.flatMap(() => [{ wch: 20 }, { wch: 10 }]), // Project columns
    ];

    // Define the header cell style
    const headerCellStyle = {
      font: {
        bold: true, // Make text bold
        color: {
          rgb: 'FFFFFF', // Set the font color to white
        },
      },
      fill: {
        fgColor: {
          rgb: '4F81BD', // Set the background color to blue (4F81BD)
        },
      },
      alignment: {
        horizontal: 'center', // Center align text horizontally
        vertical: 'center', // Center align text vertically
      },
    };

    // Apply styles to header rows
    for (let i = 0; i < headerRow1.length; i++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i });
      if (!ws[cellAddress]) {
        ws[cellAddress] = { t: 's', v: headerRow1[i] }; // Create the cell if it doesn't exist
      }
      ws[cellAddress].s = headerCellStyle; // Apply style to header cell
    }

    for (let i = 0; i < headerRow2.length; i++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 1, c: i });
      if (!ws[cellAddress]) {
        ws[cellAddress] = { t: 's', v: headerRow2[i] }; // Create the cell if it doesn't exist
      }
      ws[cellAddress].s = headerCellStyle; // Apply style to header cell
    }

    // Create a workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Employee Data');

    // Save to file
    XLSX.writeFile(wb, 'Employee wise Project Billing.xlsx');
    this.loadprojectexcel = false;
  }

  // Helper function to convert time (hh:mm:ss) to total seconds
  convertTimeToSeconds(time) {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  // Helper function to convert total seconds back to hh:mm:ss format
  convertSecondsToTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${this.padWithZero(hours)}:${this.padWithZero(
      minutes
    )}:${this.padWithZero(remainingSeconds)}`;
  }

  // Helper function to pad single-digit hours, minutes, and seconds with a leading zero
  padWithZero(value) {
    return value < 10 ? '0' + value : value;
  }

  filterClass: string = 'filter-invisible';
  isFilterApplied: string = 'default';

  applyFilter() {
    // this.getMonthAndYear();
    // this.getDaysOfMonth(this.month, this.year);

    this.isFilterApplied = 'primary';
    this.filterClass = 'filter-invisible';
  }

  loadprojectexcel: boolean = false;

  projectID = [];
  projectList = [];

  isVisible: boolean = false;
  private draggedProject: any;
  private draggedIndex: number;

  // Drag start event handler
  onDragStart(event: DragEvent, project: any, index: number) {
    this.draggedProject = project;
    this.draggedIndex = index;

    // Set the data being dragged (optional)
    event.dataTransfer?.setData('text', project.name);
  }

  // Drag over event handler (allow dropping)
  onDragOver(event: DragEvent) {
    event.preventDefault(); // Allow dropping
  }

  // Drop event handler
  onDrop(event: DragEvent, dropIndex: number) {
    event.preventDefault();
    if (this.draggedIndex !== dropIndex) {
      this.projectList = this.rearrangeList(
        this.projectList,
        this.draggedIndex,
        dropIndex
      );
    }
  }

  onDragEnd(event: DragEvent) {}

  rearrangeList(list: any[], fromIndex: number, toIndex: number): any[] {
    const result = [...list];
    const [movedItem] = result.splice(fromIndex, 1);
    result.splice(toIndex, 0, movedItem);
    return result;
  }

  newStartDate: any;
  newEndDate: any;
  isConfirmLoading: boolean = false;
  switchValue: boolean = false;
  popConfirmTitle: string = '';
  openModal(): void {
    this.newStartDate = this.startDate;
    this.newEndDate = this.endDate;
    this.projectList = [];
    this.loadingRecords = true;
    // this.loadPushData =  true ;

    this._apiService.getemployeeUpdatedSeqProcjet(this.startDate).subscribe(
      (projectData) => {
        if (projectData['code'] == 200) {
          this.projectList = projectData['results'];
          for (var i = 0; i < this.projectList.length; i++) {
            this.projectID.push(this.projectList[i]['ID']);
          }
          this.isVisible = true;
          this.loadingRecords = false;
          // this.loadPushData =  false ;
        } else {
          this.isVisible = false;
          this.loadingRecords = false;
          // this.loadPushData =  false ;

          this.notificationService.error('Failed To Get Data...', '');
        }
      },
      (err) => {}
    );
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  save(): void {
    this.newStartDate = this.startDate;
    this.newEndDate = this.endDate;
    this.projectData = [];

    // Call getemployeeUpdatedSeqProcjet to fetch project data
    this._apiService.getemployeeUpdatedSeqProcjet(this.newStartDate).subscribe(
      (projectData) => {
        if (projectData['code'] == 200) {
          this.projectList = projectData['results'];
          // Directly assign the project IDs
          this.projectID = this.projectList.map((project) => project['ID']);

          // After retrieving the project data, check if the project list has items
          if (this.projectList.length > 0) {
            // Proceed with checking billing data if the project list is non-empty
            if (this.newStartDate && this.newEndDate) {
              const dataToSave = {
                startDate: this.newStartDate,
                endDate: this.newEndDate,
              };

              // Call checkExistsBilling API inside the success callback of getemployeeUpdatedSeqProcjet
              this._apiService.checkExistsBilling(dataToSave).subscribe(
                (data) => {
                  if (data['code'] == '200') {
                    if (data['IS_EXISTS'] == 1) {
                      console.log(data['IS_EXISTS']);
                      // Data exists, show confirmation modal
                      this.showConfirm(); // This will show the confirmation modal
                    } else {
                      this.handleOk(true);
                    }
                  } else {
                    this.notificationService.error(
                      'Failed to check billing data',
                      ''
                    );
                  }
                },
                (error) => {
                  this.notificationService.error(
                    'An error occurred while checking billing data',
                    ''
                  );
                }
              );
            }
          }
        } else {
          // Handle the case when the project data is not retrieved successfully
          this.notificationService.error('Failed to fetch project data', '');
        }
      },
      (err) => {
        this.notificationService.error(
          'An error occurred while fetching project data',
          ''
        );
      }
    );
  }

  // save(): void {
  //   this.newStartDate = this.startDate;
  //   this.newEndDate = this.endDate;

  //   this._apiService.getemployeeUpdatedSeqProcjet(this.newStartDate).subscribe(
  //     (projectData) => {
  //       if (projectData['code'] == 200) {
  //         this.projectList = projectData['results'];
  //         // Directly assign the project IDs
  //         this.projectID = this.projectList.map((project) => project['ID']);
  //       } else {
  //         // this.isVisible = false;
  //         // this.loadingRecords = false;
  //       }
  //     },
  //     (err) => {
  //       this.notificationService.error(
  //         'An error occurred while fetching project data',
  //         ''
  //       );
  //       // Handle any other necessary error actions
  //     }
  //   );
  //   console.log(this.projectList.length);

  //   if (this.projectList.length > 0) {
  //     // this.isConfirmLoading = true; // Start loader

  //     if (this.newStartDate && this.newEndDate) {
  //       const dataToSave = {
  //         startDate: this.newStartDate,
  //         endDate: this.newEndDate,
  //       };

  //       this._apiService.checkExistsBilling(dataToSave).subscribe(
  //         (data) => {
  //           if (data['code'] == '200') {
  //             if (data['IS_EXISTS'] == 1) {
  //               console.log(data['IS_EXISTS']);

  //               // Data exists, show confirmation modal
  //               this.showConfirm(); // This will show the confirmation modal
  //             } else {
  //               // this.switchValue = true;
  //               this.handleOk(true);
  //               // this.isVisible = false;
  //             }
  //           } else {
  //             this.notificationService.error(
  //               'Failed to check billing data',
  //               ''
  //             );
  //           }
  //           // this.isConfirmLoading = false; // Stop loader
  //         },
  //         (error) => {
  //           this.notificationService.error(
  //             'An error occurred while checking billing data',
  //             ''
  //           );
  //           // this.isConfirmLoading = false; // Stop loader
  //         }
  //       );
  //     }
  //   }
  // }

  showConfirm(): void {
    this.modal.confirm({
      nzTitle: '<i>Existing Data Detected</i>',
      nzContent:
        '<b>It looks like data has already been generated previously. Do you want to drop the existing data and create new data?</b>',
      nzOnOk: () => {
        // This will be called when the user clicks "OK"
        this.onConfirm(); // Call the onConfirm method to proceed with saving the data
      },
      nzOnCancel: () => {
        // Handle the case where the user cancels the action
      },
    });
  }

  onConfirm(): void {
    //

    this.handleOk(true);
  }

  handleOk(saveAndClose: boolean): void {
    if (!saveAndClose) return;

    if (!this.projectList || this.projectList.length === 0) {
      this.notificationService.error(
        'Project list is empty. Please add at least one project before saving.',
        ''
      );
      return;
    }

    this.loadingRecords = true;
    // const updatedProjectList = this.projectList.map((project, index) => ({
    //   NAME: project.NAME,
    //   NEW_UPDATED_SEQ_NO: index + 1,
    // }));

    const dataToSave = {
      startDate: this.newStartDate,
      endDate: this.newEndDate,
      projectData: this.projectList,
    };

    this._apiService.MapChangedSequence(dataToSave).subscribe(
      (data) => {
        if (data['code'] == '200') {
          this.notificationService.success('Data pushed successfully', '');
          this.isVisible = false;
          this.loadingRecords = false;
        } else {
          this.notificationService.error('Failed to push data', '');
          this.loadingRecords = false;
        }
      },
      (error) => {
        console.error('Error:', error);
        this.notificationService.error(
          'An error occurred while updating sequence numbers',
          ''
        );
        this.loadingRecords = false;
      }
    );
  }

 
}
